(($) => {
  Drupal.behaviors.mainMenuSubmenus = {
    attach(context) {
      const openStateFlag = 'is-open';
      const $submenuWrapper = $('.hwp-main-menu__list-submenu');

      function closeSubmenu(submenu) {
        const trigger = submenu
          .parents(`.${openStateFlag}`)
          .eq(0)
          .removeClass(openStateFlag)
          .find('.js-hwp-main-menu__submenu-trigger');

        const isExpanded = trigger.attr('aria-expanded') === 'true';
        trigger.attr('aria-expanded', !isExpanded);
      }
      // Detect the focusout event on the submenu level,
      // so we can close the submenu after the user tabbed out of it.
      $submenuWrapper.on('focusout', function (event) {
        if ($.contains(this, event.relatedTarget)) {
          return;
        }
        closeSubmenu($(this));
      });

      $(document)
        .on('keydown', function (event) {
          // Detect the Escape key press event on global, so we can close the submenu.
          if (event.key === 'Escape') {
            closeSubmenu($submenuWrapper);
          }
        })
        .on('click', function (event) {
          // Close submenus on outside click.
          if (!$(event.target).closest('.hwp-main-menu__item').length) {
            closeSubmenu($submenuWrapper);
          }
        });

      $(
        once(
          'main-menu-submenu-trigger',
          '.js-hwp-main-menu__submenu-trigger',
          context,
        ),
      ).on('click', function () {
        const $this = $(this);
        const $submenu = $this
          .closest('.hwp-expanded-item--wrapper')
          .next('.hwp-main-menu__list-submenu');
        const $parentItem = $this.closest('.hwp-main-menu__item--has-submenu');

        // Make sure just one dropdown can be opened at the same time.
        $('.hwp-main-menu__list-submenu', context)
          .not($submenu)
          .closest('.hwp-main-menu__item--has-submenu')
          .removeClass(openStateFlag)
          .find('.js-hwp-main-menu__submenu-trigger')
          .attr('aria-expanded', 'false');

        if ($parentItem.hasClass(openStateFlag)) {
          $this.attr('aria-expanded', 'false');
          $parentItem.removeClass([
            openStateFlag,
            'hwp-main-menu__list-submenu--reversed',
          ]);
        } else {
          $this.attr('aria-expanded', 'true');
          $parentItem.addClass(openStateFlag);

          // If the submenu overflows beyond screen border - reverse the submenu orientation.
          if (
            $submenu.offset().left + $submenu.outerWidth() >
            $(window).width()
          ) {
            $submenu.addClass('hwp-main-menu__list-submenu--reversed');
          }
        }
      });
    },
  };
})(jQuery);
